import { Component, DestroyRef, inject, OnInit } from "@angular/core"
import { takeUntilDestroyed } from "@angular/core/rxjs-interop"
import { RouterOutlet } from "@angular/router"
import { MsalBroadcastService, MsalService } from "@azure/msal-angular"
import { EventMessage, EventType, InteractionStatus } from "@azure/msal-browser"
import { filter } from "rxjs/operators"

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
    private readonly destroyRef = inject(DestroyRef)
    private readonly authService = inject(MsalService)
    private readonly msalBroadcastService = inject(MsalBroadcastService)

    ngOnInit(): void {
        this.authService.handleRedirectObservable().subscribe()

        this.msalBroadcastService.msalSubject$
            .pipe(
                filter(
                    (msg: EventMessage) =>
                        msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.LOGOUT_SUCCESS
                ),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(() => {
                if (this.authService.instance.getAllAccounts().length === 0) {
                    window.location.pathname = "/"
                }
            })

        this.msalBroadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(() => {
                this.checkAndSetActiveAccount()
            })
    }

    /**
     * If no active account is set but accounts are signed in, sets the first one active.
     */
    private checkAndSetActiveAccount() {
        const activeAccount = this.authService.instance.getActiveAccount()

        if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
            this.authService.instance.setActiveAccount(this.authService.instance.getAllAccounts()[0])
        }
    }
}
